import type { ReactNode } from 'react'
import React from 'react'
import { csx } from '@vtex/admin-ui'

export type AvailabilityOptionDrawerItemProps = {
  icon: ReactNode
  title: ReactNode
  description: ReactNode
  price: ReactNode
  info?: ReactNode
}

export const AvailabilityOptionDrawerItem = ({
  icon,
  title,
  description,
  price,
  info,
  ...props
}: AvailabilityOptionDrawerItemProps) => (
  <div
    className={csx({
      paddingY: '$space-5',
      ':not(:last-child)': {
        borderBottom: '$neutral',
      },
    })}
    {...props}
  >
    <div
      className={csx({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      })}
    >
      <div
        className={csx({
          display: 'flex',
          alignItems: 'center',
        })}
      >
        {icon}
      </div>
      {price}
    </div>
    <div
      className={csx({
        marginTop: '$space-4',
      })}
    >
      {title}
    </div>
    <div
      className={csx({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '26px',
      })}
    >
      {description}
      <div
        className={csx({
          '> *:not(:last-child)': {
            marginRight: '$space-1',
          },
        })}
      >
        {info}
      </div>
    </div>
  </div>
)
